module.exports = __webpack_public_path__ + "static/Kreuzung_Hubertstrasse_Luisenstrasse-11d1f4b2649dd73fa6b9e948fd9d43c8.png";